var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAv10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1587_43606",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 106,
    height: 106
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    fill: "#EAEAEA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1587_43606)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1587_43606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2554 106.511C82.6676 106.511 106.511 82.6676 106.511 53.2554C106.511 23.8433 82.6676 0 53.2554 0C23.8433 0 0 23.8433 0 53.2554C0 82.6676 23.8433 106.511 53.2554 106.511Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2562 37.2462V76.1108C84.2562 91.4849 71.675 104.064 56.3009 104.064H50.4761C35.102 104.064 22.5229 91.4849 22.5229 76.1108V37.2462C22.5462 29.8397 25.4987 22.7432 30.7359 17.506C35.9732 12.2688 43.0696 9.31623 50.4761 9.29297H56.3009C71.675 9.29297 84.2562 21.872 84.2562 37.2462Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6843 148.134V124.14C73.6843 113.456 64.9418 104.714 54.2584 104.714H52.5198C41.8343 104.714 33.0918 113.456 33.0918 124.14V148.134H73.6843Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6834 107.801V94.1442C67.6721 90.3553 66.1621 86.7249 63.4831 84.0455C60.8042 81.3662 57.174 79.8557 53.3851 79.8438C49.5959 79.8551 45.9651 81.3654 43.2858 84.0448C40.6064 86.7242 39.0961 90.355 39.0847 94.1442V107.801H67.6834Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3888 89.0812C51.7806 89.0812 50.2383 88.4424 49.1012 87.3053C47.964 86.1681 47.3252 84.6258 47.3252 83.0176V76.9218C47.3258 75.314 47.9649 73.7722 49.1019 72.6356C50.239 71.4989 51.781 70.8604 53.3888 70.8604C54.1848 70.8604 54.973 71.0171 55.7084 71.3218C56.4438 71.6264 57.112 72.0728 57.6749 72.6357C58.2377 73.1986 58.6842 73.8668 58.9888 74.6022C59.2934 75.3376 59.4502 76.1258 59.4502 76.9218V83.009C59.4516 83.8059 59.2959 84.5953 58.9919 85.332C58.6879 86.0686 58.2417 86.7381 57.6787 87.3021C57.1157 87.8661 56.447 88.3135 55.7109 88.6188C54.9748 88.9241 54.1857 89.0812 53.3888 89.0812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.389 13.708H53.3869C37.6267 13.708 24.8506 26.4841 24.8506 42.2443V48.2455C24.8506 64.0057 37.6267 76.7818 53.3869 76.7818H53.389C69.1492 76.7818 81.9253 64.0057 81.9253 48.2455V42.2443C81.9253 26.4841 69.1492 13.708 53.389 13.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9749 56.4278C29.9824 54.4204 29.9824 51.1656 27.9749 49.1581C25.9675 47.1506 22.7127 47.1506 20.7052 49.1581C18.6977 51.1656 18.6977 54.4204 20.7052 56.4278C22.7127 58.4353 25.9675 58.4353 27.9749 56.4278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4828 53.7539C88.0172 50.9656 86.1901 48.272 83.4018 47.7376C80.6136 47.2032 77.92 49.0303 77.3856 51.8186C76.8512 54.6069 78.6783 57.3004 81.4666 57.8348C84.2548 58.3692 86.9484 56.5421 87.4828 53.7539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4436 58.4385C35.4436 58.7957 34.9186 59.084 34.2688 59.084C33.619 59.084 33.0918 58.7957 33.0918 58.4385C33.0918 58.0813 33.619 57.793 34.2688 57.793C34.9186 57.793 35.4436 58.0813 35.4436 58.4385Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1275 58.4385C39.1275 58.7957 38.6003 59.084 37.9505 59.084C37.3007 59.084 36.7756 58.7957 36.7756 58.4385C36.7756 58.0813 37.3007 57.793 37.9505 57.793C38.6003 57.793 39.1275 58.0813 39.1275 58.4385Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4236 60.1367C37.4236 60.4939 36.8964 60.7823 36.2466 60.7823C35.5968 60.7823 35.0718 60.4939 35.0718 60.1367C35.0718 59.7795 35.599 59.4912 36.2466 59.4912C36.8943 59.4912 37.4236 59.7795 37.4236 60.1367Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1433 60.1367C41.1433 60.4939 40.6161 60.7823 39.9663 60.7823C39.3165 60.7823 38.7893 60.4939 38.7893 60.1367C38.7893 59.7795 39.3165 59.4912 39.9663 59.4912C40.6161 59.4912 41.1433 59.7795 41.1433 60.1367Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8203 58.4385C42.8203 58.7957 42.2953 59.084 41.6455 59.084C40.9957 59.084 40.4685 58.7957 40.4685 58.4385C40.4685 58.0813 40.9957 57.793 41.6455 57.793C42.2953 57.793 42.8203 58.0813 42.8203 58.4385Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7471 58.4385C65.7471 58.7957 65.2199 59.084 64.5701 59.084C63.9202 59.084 63.3931 58.7957 63.3931 58.4385C63.3931 58.0813 63.9202 57.793 64.5701 57.793C65.2199 57.793 65.7471 58.0813 65.7471 58.4385Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4285 58.4385C69.4285 58.7957 68.9013 59.084 68.2537 59.084C67.606 59.084 67.0767 58.7957 67.0767 58.4385C67.0767 58.0813 67.6038 57.793 68.2537 57.793C68.9035 57.793 69.4285 58.0813 69.4285 58.4385Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7239 60.1367C67.7239 60.4939 67.1989 60.7823 66.5491 60.7823C65.8992 60.7823 65.3721 60.4939 65.3721 60.1367C65.3721 59.7795 65.8992 59.4912 66.5491 59.4912C67.1989 59.4912 67.7239 59.7795 67.7239 60.1367Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4383 60.1367C71.4383 60.4939 70.9111 60.7823 70.2613 60.7823C69.6114 60.7823 69.0864 60.4939 69.0864 60.1367C69.0864 59.7795 69.6114 59.4912 70.2613 59.4912C70.9111 59.4912 71.4383 59.7795 71.4383 60.1367Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1125 58.4385C73.1125 58.7957 72.5854 59.084 71.9355 59.084C71.2857 59.084 70.7585 58.7957 70.7585 58.4385C70.7585 58.0813 71.2857 57.793 71.9355 57.793C72.5854 57.793 73.1125 58.0813 73.1125 58.4385Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9669 54.2985C41.2776 54.2985 42.3402 53.2359 42.3402 51.9251C42.3402 50.6144 41.2776 49.5518 39.9669 49.5518C38.6561 49.5518 37.5935 50.6144 37.5935 51.9251C37.5935 53.2359 38.6561 54.2985 39.9669 54.2985Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8099 54.2985C68.1207 54.2985 69.1832 53.2359 69.1832 51.9251C69.1832 50.6144 68.1207 49.5518 66.8099 49.5518C65.4991 49.5518 64.4365 50.6144 64.4365 51.9251C64.4365 53.2359 65.4991 54.2985 66.8099 54.2985Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5508 55.8906V61.7541C49.5536 62.7713 49.959 63.7461 50.6782 64.4653C51.3975 65.1846 52.3723 65.59 53.3895 65.5928C54.408 65.5917 55.3846 65.1871 56.1056 64.4677C56.8267 63.7483 57.2334 62.7726 57.2368 61.7541V55.8906H49.5508Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2559 37.2461V38.7782C78.2599 43.4141 70.8923 45.9242 63.3131 45.9133C55.424 45.9126 47.7763 43.1921 41.6591 38.2104C35.5419 33.2286 31.3292 26.2903 29.731 18.5648C32.3439 15.6493 35.5416 13.3169 39.1159 11.7194C42.6901 10.1219 46.5608 9.29514 50.4758 9.29297H56.3006C71.6747 9.29297 84.2559 21.872 84.2559 37.2461Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9092 97.2539H39.1274V122.903H44.9092V97.2539Z",
    fill: "#C5C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6875 97.2539H61.9058V122.903H67.6875V97.2539Z",
    fill: "#C5C1FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1587_43606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAv10);
export default __webpack_public_path__ + "static/media/Av10.154e03b710991e0d4b0fa817c2160085.svg";
export { ForwardRef as ReactComponent };